import { ManagedSyncStatus } from '@/types/api';

export function getSyncStatusBadge(status: ManagedSyncStatus | string) {
  switch (status) {
    case ManagedSyncStatus.PENDING_SYNC:
    case 'PENDING_SYNC':
      return { className: 'bg-yellow-100 text-yellow-800', label: 'Pending Sync' };
    case ManagedSyncStatus.SYNCED:
    case 'SYNCED':
      return { className: 'bg-green-100 text-green-800', label: 'Synced' };
    case 'SYNC_FAILED':
      return { className: 'bg-red-100 text-red-800', label: 'Sync Failed' };
    case 'LOCAL_ONLY':
      return { className: 'bg-gray-100 text-gray-800', label: 'Local Only' };
    case ManagedSyncStatus.CONFLICT:
    case 'CONFLICT':
      return { className: 'bg-red-100 text-red-800', label: 'Conflict' };
    case ManagedSyncStatus.NOT_SYNCED:
    case 'NOT_SYNCED':
      return { className: 'bg-gray-100 text-gray-800', label: 'Not Synced' };
    default:
      return { className: 'bg-gray-100 text-gray-800', label: String(status) };
  }
}
